import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FiltroPadraoService } from '../../../../services/filtro-padrao.service';
import { FieldTypeEnum } from '../../../../enums/fieldType.enum';
import {
  DEFAULT_OPERADOR_LOGICO_AND_ID,
  DEFAULT_OPERADOR_LOGICO_OR_ID,
  ENTIDADE_TICKET_ID,
  ENTIDADES_FILTRO,
  montaOperadores,
  OPERADOR_ENTRE_ID,
  TIPOS_OPERADOR_PERIODO
} from '../../helpers/filtro-avancado-v2.helper';

@Component({
  selector: 'app-modal-periodo-filtro-avancado-v2',
  templateUrl: './modal-periodo-filtro-avancado-v2.component.html',
  styleUrls: ['./modal-periodo-filtro-avancado-v2.component.scss']
})
export class ModalPeriodoFiltroAvancadoV2Component implements OnInit {
  @Input() periodo: any;
  @Input() mostrarOperadorLogico = false;
  @Input() operadorLogicoAtual = DEFAULT_OPERADOR_LOGICO_AND_ID;

  periodoForm: UntypedFormGroup;
  create = true;
  tentouSalvar = false;
  campoSelecionado: any = null;
  entidadesFiltro = ENTIDADES_FILTRO;
  valorDinamicoSelecionado: any = null;

  readonly fieldTypeEnum = FieldTypeEnum;
  readonly operadoresLogicos = [
    { id: DEFAULT_OPERADOR_LOGICO_AND_ID, text: 'E' },
    { id: DEFAULT_OPERADOR_LOGICO_OR_ID, text: 'OU' }
  ];
  operadoresPeriodo: Array<{ id: number; text: string; tipo_operador_id: number }> = [];

  private datasDinamicas: any[] = [];
  private selector: string;

  constructor(
    public modal: NgbActiveModal,
    private elemRef: ElementRef,
    private fb: UntypedFormBuilder,
    private filtrosService: FiltroPadraoService
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]['style']['zoom'] = '0.85';
    this.create = !this.periodo;
    this.buildForm();
    this.carregaDatasDinamicas();
    this.carregaOperadores();
  }

  carregaOperadores(): void {
    this.filtrosService.getDropdownOperadores({ tipo_campo_id: this.fieldTypeEnum.Data }).subscribe(
      (results) => this.operadoresPeriodo = montaOperadores(results, TIPOS_OPERADOR_PERIODO),
      () => this.operadoresPeriodo = []
    );
  }

  isOperadorEntre(): boolean {
    const operador = this.operadoresPeriodo.find((item) => item.id === Number(this.periodoForm.value.operador_id));
    return operador?.tipo_operador_id === OPERADOR_ENTRE_ID;
  }

  buildForm(): void {
    this.periodoForm = this.fb.group({
      campo_id: [this.periodo?.campo_id || null, Validators.required],
      campo_text: [this.periodo?.campo_text || null],
      operador_id: [this.periodo?.operador_id || null, Validators.required],
      dinamico: [this.periodo?.dinamico === true, Validators.required],
      valor: [this.periodo?.valor || null],
      valor_inicio: [this.periodo?.valor_inicio || null],
      valor_fim: [this.periodo?.valor_fim || null],
      entidade_id: [this.periodo?.entidade_id || ENTIDADE_TICKET_ID, Validators.required],
      tipo_campo_id: [this.periodo?.tipo_campo_id || this.fieldTypeEnum.Data],
      campo_chave: [this.periodo?.campo_chave || null],
      operador_logico_id: [this.mostrarOperadorLogico ? (this.periodo?.operador_logico_id || this.operadorLogicoAtual) : null]
    });


    if (this.periodo) {
      this.campoSelecionado = { id: this.periodo.campo_id, text: this.periodo.campo_text };
    }
  }

  carregaDatasDinamicas(): void {
    this.filtrosService.getDropdownValores('$datas').subscribe(
      (results) => {
        this.datasDinamicas = results || [];
        if (this.periodo?.dinamico) {
          this.valorDinamicoSelecionado = this.datasDinamicas.find((data) => data.chave === this.periodo.valor) || null;
        }
      },
      (error) => console.error('carregaDatasDinamicas', error)
    );
  }

  // Todo campo de período é data: trocar o campo mantém o valor já escolhido (a tela continua exibindo esse valor).
  patchCampoPeriodo(campo: any): void {
    this.periodoForm.patchValue({
      campo_id: campo ? campo.id : null,
      campo_text: campo ? this.getCampoText(campo) : null,
      tipo_campo_id: campo ? campo.tipo_campo_id : this.fieldTypeEnum.Data,
      campo_chave: campo ? campo.chave : null
    });
  }

  changePeriodoDinamico(): void {
    const dinamico = this.periodoForm.value.dinamico === true;
    this.periodoForm.patchValue({ dinamico, valor: null, valor_inicio: null, valor_fim: null });
    this.valorDinamicoSelecionado = null;
  }

  patchDataDinamicaPeriodo(value): void {
    this.periodoForm.patchValue({ valor: value ? value.chave : null });
  }

  periodoValorValido(): boolean {
    if (this.isOperadorEntre() && !this.periodoForm.value.dinamico) {
      return !!this.periodoForm.value.valor_inicio && !!this.periodoForm.value.valor_fim;
    }

    return !!this.periodoForm.value.valor;
  }

  salvar(): void {
    this.tentouSalvar = true;

    if (this.periodoForm.invalid || !this.periodoValorValido()) {
      this.periodoForm.markAllAsTouched();
      return;
    }

    // "Entre" grava o intervalo em valor; nos demais operadores o intervalo não é usado.
    if (this.isOperadorEntre() && !this.periodoForm.value.dinamico) {
      this.periodoForm.patchValue({ valor: [this.periodoForm.value.valor_inicio, this.periodoForm.value.valor_fim] });
    } else {
      this.periodoForm.patchValue({ valor_inicio: null, valor_fim: null });
    }

    this.modal.close(this.periodoForm.value);
  }

  close(): void {
    this.modal.dismiss();
  }

  private getCampoText(campo: any): string {
    return campo.text || campo.label || campo.nome || campo.descricao;
  }
}
